import {parseTime} from '@/utils';
import { mapState } from 'vuex';
export default{
  computed: {
    ...mapState({
      emitName: state => state.const.emitName
    })
  },
  methods: {
    // 手动拼接小云消息
    generateXiaoyu (data) {
      const type = data.subclass;
      const extra = data.extra || {};
      // 新客池存量过多
      if (type == 701) {
        const msg = [`新客池最近 3 天内每天都有积累下来的客户未分配，目前共积累了 ${extra.remaining_num || 0} 名客户，陆续还有线上新客户进线哦~；`];
        if (extra.distribute_type_active == 1) msg.push('使用建议：推荐使用[系统自动分配]或者[经纪人手动抢客]模式，以便及时跟进客户。');
        else if (extra.distribute_type_active == 3) msg.push('使用建议：推荐使用[系统自动分配]模式，以便及时跟进客户。');
        return msg;
      }
      // 云来客存量过多 
      if (type == 702) {
        return [`目前共积累了 ${extra.remaining_num || 0} 名客户，陆续还有线上新客户进线哦~；使用建议：请督促经纪人抢客，抓住每一次成交机会。`]
      }
      // 400使用情况分析
      if (type == 703) {
        const msg = [`坐席未接听400通话数为 ${extra.line_total || 0}，截止到 ${parseTime(extra.end_ts * 1000, '{y}年{m}月{d}日')} 有 ${extra.public_customer_total || 0} 名客户进入公客池，${extra.invalid_customer_total || 0} 名客户进入无效池，${extra.follow_customer_total || 0} 名客户正在跟进中，${extra.look_customer_total || 0} 名客户带看成功。`];
        if ((extra.line_list || []).length > 0) {
          extra.line_list.map(v => {
            msg.push(`未接通分机号为：${v.ext_line}，未接听的经纪人是 ${(v.admin_names || []).join(' 和 ')}；`);
          })
        }
        if (extra.line_total > 4) {
          msg.push('...');
        }
        msg.push('使用建议：1）经纪人需关注手机来电，避免错过；2）未接到的电话需及时回拨；');
        return msg;
      }
      if (type == 702) {
        return [`目前共积累了 ${extra.remaining_num || 0} 名客户，陆续还有线上新客户进线哦~；使用建议：请督促经纪人抢客，抓住每一次成交机会。`]
      }
      // 3.小云智能 -400监控
      if (type == 721) {
        const msg = [`经纪人（${extra.admin_name} - ${extra.admin_tel.substr(-4)}）有 ${extra.line_total} 通电话未接听`];
       
        msg.push(`统计时间段：${parseTime(extra.end_ts * 1000, '{y}年{m}月{d}日 {h}:{i}:{s}')}`);
        return msg;
      }
        //小云智能 -潜在成交客户掉落
      if (type == 710) {
          const msg = [];
          if ((extra.record_list || []).length > 0) {
            extra.record_list.map(v => {
              msg.push(`${parseTime(v.time * 1000, '{y}年{m}月{d}日')},${v.text}`);
            })
          }
          msg.push(`提醒时间${parseTime(data.trigger_time * 1000, '{y}年{m}月{d}日 {h}:{i}:{s}')}`);
          return msg;
      }
      // 3.小云智能 -客户跟进情况
      if (type == 711) {
        const msg = [`经纪人（${extra.admin_name}） 1小时跟进率低`];
        
        msg.push(`提醒时间${parseTime(data.trigger_time * 1000, '{y}年{m}月{d}日 {h}:{i}:{s}')}`);
        return msg;
      }
      //客户跟进情况
      if (type == 713) {
        const msg = [`经纪人（${extra.admin_name}） 及时跟进客户，但客户的意向填写不全。`];
        
        msg.push(`提醒时间${parseTime(data.trigger_time * 1000, '{y}年{m}月{d}日 {h}:{i}:{s}')}`);
        return msg;
      }
       // 1 小时跟进率低
       if (type == 712) {
        const msg = ['您跟进客户不及时，与其他经纪人跟进客户水平还有差距。','据大数据统计，跟进客户越及时成交几率越大'];
        
        msg.push(`提醒时间${parseTime(data.trigger_time * 1000, '{y}年{m}月{d}日 {h}:{i}:{s}')}`);
        return msg;
      }
    
       // 1 小时跟进率高于对比值 但 客户资料填写率低
       if (type == 714) {
        const msg = ['您跟进客户填写的意向资料太少。','希望能积极将客户意向录入系统，这将有助于小云为您提供更多服务'];
        
        msg.push(`提醒时间${parseTime(data.trigger_time * 1000, '{y}年{m}月{d}日 {h}:{i}:{s}')}`);
        return msg;
      }
     
      // 手工分配-被动接收人
      if (type == 715) {
        const msg = [`新客池共积累了 ${extra.remaining_num} 名客户，其中有 ${extra.remaining_repeat_num} 名客户有重复进线`];
        msg.push(`提醒时间${parseTime(data.trigger_time * 1000, '{y}年{m}月{d}日 {h}:{i}:{s}')}`);
        return msg;
      }
       // 手动分配 - 指定接收人
       if (type == 716) {
        const msg = [`新客池共积累了 ${extra.remaining_num} 名客户，陆续还有新客户进线`,`管理员分配新客速度慢，可能导致意向客户流失。`,`新客户分配规则 推荐切换成 【系统自动分配】或者【经纪人手动抢客】模式，以便及时跟进客户`];
        msg.push(`提醒时间${parseTime(data.trigger_time * 1000, '{y}年{m}月{d}日 {h}:{i}:{s}')}`);
        return msg;
      }
       // 手动抢客 - 被动接收人
       if (type == 717) {
        const msg = [];
        msg.push(`提醒时间${parseTime(data.trigger_time * 1000, '{y}年{m}月{d}日 {h}:{i}:{s}')}`);
        return msg;
      }
      //手动抢客 - 指定接收人
      if (type == 718) {
        const msg = [`新客池共积累了 ${extra.remaining_num} 名客户，赶紧提醒经纪人抢客！`,`新客户分配规则 推荐切换成 【系统自动分配】模式，以便及时跟进客户`];
        msg.push(`提醒时间${parseTime(data.trigger_time * 1000, '{y}年{m}月{d}日 {h}:{i}:{s}')}`);
        return msg;
      }
       //抢客池留存消息 - 指定接收人
       if (type == 719) {
        const msg = [`小云结合好房云大数据智能库分析，目前有 ${extra.remaining_num} 名优质潜在成交客户`,`请督促经纪人抢客，抓住每一次成交机会`];
        msg.push(`提醒时间${parseTime(data.trigger_time * 1000, '{y}年{m}月{d}日 {h}:{i}:{s}')}`);
        return msg;
      }
       //公客池客户利用率的实时监控
       if (type == 720) {
        const msg = [`经纪人（${extra.owner_name} - ${extra.owner_account.substr(-4)}）挖掘旧客意向，并成功报备！`];
       if(extra.owner_get_type == 3){
        msg.push(`${parseTime(extra.owner_get_time * 1000, '{y}年{m}月{d}日')},公客池客户通过自动唤醒将客户分配给经纪人（${extra.owner_name}）`);
       }else if(extra.owner_get_type == 1){
        msg.push(`${parseTime(extra.owner_get_time * 1000, '{y}年{m}月{d}日')},公客池客户通过（管理员手手工分配）归属给经纪人（${extra.owner_name}）`)
       }else if(extra.owner_get_type == 2){
        msg.push(`${parseTime(extra.owner_get_time * 1000, '{y}年{m}月{d}日')},公客池客户通过（经纪人自主抢客）归属给经纪人（${extra.owner_name}）`)
       }
       if(extra.public_usage_type == 6 ){
        msg.push(`${parseTime(extra.owner_handle_time * 1000, '{y}年{m}月{d}日')},客户报备成功`);
       }
       if(extra.public_usage_type == 7){
        msg.push(`${parseTime(extra.owner_handle_time * 1000, '{y}年{m}月{d}日')},客户带看成功`);
       }
        msg.push(`提醒时间${parseTime(data.trigger_time * 1000, '{y}年{m}月{d}日 {h}:{i}:{s}')}`);
        return msg;
      }
      // 公客池带看报备成功
      if (type == 705) {
        const date1 = this.computedDateRange((extra.owner_handle_time || 0) - (extra.pre_give_up_time || 0));
        const date2 = this.computedDateRange((extra.owner_handle_time || 0) - (extra.owner_get_time || 0));
        const msg = [`经纪人 - ${extra.pre_owner_name}（${extra.pre_owner_account}）放弃的客户- ${extra.customer_name} - ${extra.customer_contact_tel} ，${date1}后被经纪人 - ${extra.owner_name}（${extra.owner_account}）${extra.public_usage_type == 6 ? '报备' : '带看'}啦！`];
        if (extra.pre_flow_time > 0) {
          msg.push(`${parseTime(extra.pre_flow_time * 1000, '{y}年{m}月{d}日')}经纪人 （${extra.pre_owner_name}）提交客户${extra.pre_flow_string}；`);
        }      
        msg.push(`${parseTime(extra.pre_give_up_time * 1000, '{y}年{m}月{d}日')} 经纪人 ${extra.pre_owner_name} 放弃客户，原因：${extra.pre_give_up_reason}；`);  
        msg.push(`${parseTime(extra.owner_get_time * 1000, '{y}年{m}月{d}日')} 经纪人 ${extra.owner_name} 获得该客户，${date2}后带看；`);
        msg.push(`给经纪人 ${extra.pre_owner_name} 的建议：学习促进带看客户的跟进方法，必要时进行团队合作；`);
        return msg;
      }
      // 客户等级变更
      if (type == 706) {
        return [
          `经纪人-${extra.owner_name}（${extra.owner_account}）将客户等级从 ${extra.old_level} 修改成 ${extra.new_level}。`,
          `使用建议：请核查客户的等级变更是否合理。`
        ]
      }
      // 客户资料不完整
      if (type == 707) {
        return [
          `经纪人 - ${extra.admin_name}（${extra.admin_tel}）其名下累计有 ${extra.admin_customer_total || 0} 名客户，其中有 ${extra.low_info_customer_total} 名客户的资料不完整。`,
          `使用建议：1）提升经纪人跟进客户意向的话术；2）督促经纪人利用系统跟进客户；`
        ];
      }
      // 公客池重复进线
      if (type == 708) {
        const msg = [`客户-${extra.repeat_customer_name}（${extra.repeat_customer_tel}） 通过【${extra.source_name}】重复报名啦！`];
        if (extra.public_pick_status == 0) {
          msg.push('使用建议：1）请管理员及时分配客户；2）推荐使用[经纪人手动抢客]模式；');
        } else if (extra.public_pick_status == 1) {
          msg.push('使用建议：1）请管理员及时分配客户；2）请督促客户及时抢客，抓住每一次成交机会；');
        }
        return msg;
      }
      // 新客户汇总
      if (type == 709) {
        const msg = [
          `本${extra.statistic_type == 3 ? '周' : '月'}新增 ${extra.total_new || 0} 名客户， 1 小时跟进率是 ${extra.follow_rate * 100}%。`,
          `截止到 ${parseTime(extra.end_ts * 1000, '{y}年{m}月{d}日')} 有 ${extra.public_pool || 0} 名客户进入公客池，${extra.invalid_pool || 0} 名客户进入无效池，${extra.black_pool || 0} 名客户进入黑名单，${extra.stage_str || ''}。`
        ]
        if (extra.follow_tip_status == 1) {
          msg.push('使用建议：首次跟进时长较长，需要督促经纪人及时跟进。');
        }
        return msg;
      }
      return [];
    },
    // 小云消息跳转交互
    async handleXiaoyuRedirect (data) {
      const type = data.subclass;
      const extra = data.extra || {};
      // 新客池存量过多
      if (type == 701 || type == 715 || type == 717) {
        const status = await this.$store.dispatch('user/hasPermission', 'customer.new.list');
        if (!status) {
          this.$message.error('你没有查看新客池的权限哦');
        } else {
          this.$router.push('/customer/newyorker/list');
        }
      }
      // 云来客存量过多
      else if (type == 702) {
        this.$router.push('/customer/housecard/list');
      }
      // 400分析
      else if (type == 703 || type == 721) {
        this.$EventBus.$emit(this.emitName, {category: 'messageUserAnalysis', params: {
          subclass: type,
          id: data.id
        }})
      }
      // 公客池带看报备成功；客户等级变更
      else if (type == 705 || type == 706 || type == 710 || type == 720) {
        const status = await this.$store.dispatch('user/hasPermission', 'customer.detail');
        if (!status) {
          this.$message.error('你没有查看该客户的详情哦');
        } else {
          this.$EventBus.$emit(this.emitName, {category: 'customerDetail', params: {
            customerId: data.customer_id
          }});
        }
      }
      // 客户资料不完整
      else if (type == 707 || type == 714) {
        this.$EventBus.$emit(this.emitName, {category: 'messageIncomplete', params: {
          subclass: type,
          id: data.id
        }})
      }
      // 公客池重复进线客户
      else if (type == 708) {
        this.$router.push('/customer/public-pool/list?public_repeat_status=1');
      }
      // 新客户汇总
      else if (type == 709) {
        this.$EventBus.$emit(this.emitName, {category: 'messageNewCustome', params: {
          subclass: type,
          id: data.id
        }})
      }
      // 客户跟进-员工分析
      else if (type == 711 || type == 713) {
        var query ={
          activeName:'userFollow',
          admin_id:extra.admin_id,
          timePicker:`${parseTime(data.trigger_time * 1000, '{y}-{m}-{d}')}`
        }
        const url = `/data-center/report/user-analysis`
        this.$router.push({path:url,query:query});
      }
      //客户管理列表-只看我的
      else if (type == 712) {
        const url = `/customer/all-custome/list`
        this.$router.push(url);
      }
      //手动分配 - 指定接收人
      else if (type == 716 || type == 718) {
        const url = `/system/bussiness/setting`
        this.$router.push(url);
      }
        // 云来客
      else if (type == 719) {
        this.$router.push('/customer/housecard/list');
      }
    },
    // 计算时间
    computedDateRange (time) {
      if (time <= 0) return '';
      if (time < 3600) return Math.ceil(time / 60) + '分钟';
      if (time < 3600 * 24) return Math.ceil(time / 3600) + '小时';
      return Math.ceil(time / (3600 * 24)) + '天';
    },
    // type是用来设置头部消息不用标蓝展示可跳转
    generateMatch (row, type) {
      const data = row.content || '';
      if (!(!!data)) return '--';
      if (data.match(/\[\[customerName\]\]/g) !== null) {
        const content = type == 1 ? row.customerName : `<a class="to-link" category="custome" id="${row.customer_id}">${row.customerName}</a>`;
        return data.replace(/\[\[customerName\]\]/g, content);
      }
      if (data.match(/\[\[approvalName\]\]/g) !== null) {
        const content = type == 1 ? row.approvalName : `<a class="to-link" category="approve" id="${row.approval_id}" voucher_type="${row.voucher_type}">${row.approvalName}</a>`;
        return data.replace(/\[\[approvalName\]\]/g, content);
      }
      if (data.match(/\[\[weworkCustomerName\]\]/g) !== null) {
        const content = type == 1 ? row.weworkCustomerName : `<a class="to-link" category="weworkCustome" id="${row.wework_customer_id}" voucher_type="${row.weworkCustomerName}">${row.weworkCustomerName}</a>`;
        return data.replace(/\[\[weworkCustomerName\]\]/g, content);
      }
      if (row.subclass == 205 && type != 1) {
        const content = `<a class="to-link" category="companyJoin" id="${row.admin_join_companys_id}">加入企业申请</a>`;
        return data.replace('加入企业申请', content);
      }
      return data;
    }
  },
}